/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiScenarioTestResultStatus {
    SCHEDULED = 'SCHEDULED',
    RUNNING = 'RUNNING',
    FINISHED = 'FINISHED',
    CANCELLED = 'CANCELLED',
    FAILED = 'FAILED'
}


export function instanceOfInternalApiScenarioTestResultStatus(value: any): boolean {
    for (const key in InternalApiScenarioTestResultStatus) {
        if (Object.prototype.hasOwnProperty.call(InternalApiScenarioTestResultStatus, key)) {
            if (InternalApiScenarioTestResultStatus[key as keyof typeof InternalApiScenarioTestResultStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiScenarioTestResultStatusFromJSON(json: any): InternalApiScenarioTestResultStatus {
    return InternalApiScenarioTestResultStatusFromJSONTyped(json, false);
}

export function InternalApiScenarioTestResultStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioTestResultStatus {
    return json as InternalApiScenarioTestResultStatus;
}

export function InternalApiScenarioTestResultStatusToJSON(value?: InternalApiScenarioTestResultStatus | null): any {
    return value as any;
}

export function InternalApiScenarioTestResultStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiScenarioTestResultStatus {
    return value as InternalApiScenarioTestResultStatus;
}

